module.exports = __webpack_public_path__ + "static/media/color-picker.6b71ee7d.svg";